var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }